import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'debtor-panel-loading-spinner-select',
  templateUrl: './loading-spinner-select.component.html',
  styleUrls: ['./loading-spinner-select.component.scss'],
  imports: [MatProgressSpinnerModule, TranslateModule ],
})
export class LoadingSpinnerSelectComponent {
  public isLoading = input.required<boolean>();
}
